import { CustomerAddress, NationalIdDocumentType } from './customer-information.model';
import { CustomerVehicleRelationType } from './customer-vehicle.model';

/**
 * View model, which is filled by both Eso CRM and Retail CRM search results.
 * The model is used to display search results.
 * It is NOT used to fill the customer profile page.
 */
export interface FoundCustomer {
  gcid?: string;
  accountNumber?: string;
  bmwMiniId?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  suffix?: string;
  address?: CustomerAddress;
  email?: string;
  phone?: string;
  mobile?: string;
  isIndividual?: boolean;
  customerToVehicleRelations?: ReadonlySet<CustomerVehicleRelationType>;
  taxNumber?: string;
  nationalId1?: string;
  nationalId1DocumentType?: NationalIdDocumentType;
  inSyncWithDirectSales?: boolean;
}

/**
 * A customer found in a search, with a definite account ID, so they are known to exist in Retail CRM.
 */
export interface FoundRetailCustomer extends FoundCustomer {
  accountNumber: string;
}

export function isRetailCustomer(customer: FoundCustomer): customer is FoundRetailCustomer {
  return !!customer.accountNumber;
}
